import { render, staticRenderFns } from "./P024.vue?vue&type=template&id=19e552af"
import script from "./P024.vue?vue&type=script&lang=js"
export * from "./P024.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports